import React, { useState, useEffect } from 'react';
import moment from 'moment';
import { useDispatch, useSelector } from 'react-redux';
import {
    sensorOptionsSelector,
    parentAllSensorList,
    createShare,
} from '../../features/subaccounts/subaccountSlice';
import {
    Box,
    Button,
    Checkbox,
    List,
    ListItem,
    ListItemButton,
    ListItemIcon,
    ListItemText,
    Typography,
} from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import ScreenShareIcon from '@mui/icons-material/ScreenShare';

const basicSensors = ['Engine', 'Main Power'];

const useStyles = makeStyles(() => ({
    panel: {
        display: 'flex',
        flexDirection: 'column',
        gap: 16,
        minHeight: 320,
    },
    title: {
        fontWeight: 600,
        color: '#0f172a',
    },
    sectionTitle: {
        fontSize: '0.85rem',
        fontWeight: 600,
        color: '#334155',
        marginBottom: 8,
    },
    sensorList: {
        padding: 0,
        borderRadius: 12,
        border: '1px solid rgba(148, 163, 184, 0.3)',
        backgroundColor: 'rgba(248, 250, 252, 0.9)',
    },
    shareButton: {
        alignSelf: 'flex-start',
        textTransform: 'none',
        borderRadius: 12,
        fontWeight: 600,
        background: 'linear-gradient(135deg, #38bdf8, #0ea5e9)',
        color: '#ffffff',
        boxShadow: '0 12px 20px rgba(14, 165, 233, 0.25)',
        '& .MuiSvgIcon-root': {
            color: '#ffffff',
        },
    },
    emptyText: {
        color: '#ef4444',
        fontWeight: 600,
    },
}));

const SubAccountShareAllVehicles = ({ assets, subAccount, selectFew }) => {
    const classes = useStyles();
    const dispatch = useDispatch();
    const sensorOptions = useSelector(sensorOptionsSelector);
    const [accessupto, setAccessupto] = useState(moment().add(7, 'days'));

    const [checked, setChecked] = useState([]);
    const handleToggle = (value) => () => {
        const currentIndex = checked.indexOf(value);
        const newChecked = [...checked];

        if (currentIndex === -1) {
            newChecked.push(value);
        } else {
            newChecked.splice(currentIndex, 1);
        }

        setChecked(newChecked);
    };

    useEffect(() => {
        if (Object.keys(assets).length === selectFew.length) {
            dispatch(parentAllSensorList());
        }
    }, [dispatch, selectFew, assets]);

    useEffect(() => {
        const initialChecked = [...basicSensors];
        setChecked(initialChecked);
    }, [sensorOptions]);

    const disableCreateShare = () => {
        let disable = false;
        if (!accessupto || accessupto === null || !selectFew || selectFew.length < 1) {
            disable = true;
        }
        return disable;
    };

    const handleCreateShare = () => {
        const submitData = {
            subuser_id: subAccount.subuser_id,
            assetIds: selectFew,
            sensorNames: checked,
            access_upto: moment(accessupto).format('YYYY-MM-DD'),
        };
        dispatch(createShare(submitData));
    };

    return (
        <Box className={classes.panel}>
            <Box>
                <Typography variant="subtitle1" className={classes.title}>
                    Sharing Options for {selectFew.length} Vehicles
                </Typography>
            </Box>
            <Box>
                <Typography className={classes.sectionTitle}>Share Up to</Typography>
                <DesktopDatePicker
                    format="DD-MMM-YYYY"
                    value={accessupto}
                    onChange={(newValue) => setAccessupto(newValue)}
                />
            </Box>
            <Box>
                <Typography className={classes.sectionTitle}>Select Sensors</Typography>
                {sensorOptions && sensorOptions.length > 0 ? (
                    <List className={classes.sensorList}>
                        {sensorOptions.map((value) => {
                            const labelId = `checkbox-list-label-${value}`;

                            return (
                                <ListItem key={`allSensor${value}`} disablePadding>
                                    <ListItemButton role={undefined} onClick={handleToggle(value)} dense>
                                        <ListItemIcon sx={{ minWidth: 32 }}>
                                            <Checkbox
                                                edge="start"
                                                checked={checked.indexOf(value) !== -1}
                                                tabIndex={-1}
                                                disableRipple
                                                inputProps={{ 'aria-labelledby': labelId }}
                                                size="small"
                                            />
                                        </ListItemIcon>
                                        <ListItemText
                                            id={labelId}
                                            primary={value}
                                            primaryTypographyProps={{ variant: 'body2' }}
                                        />
                                    </ListItemButton>
                                </ListItem>
                            );
                        })}
                    </List>
                ) : (
                    <Typography variant="body2" className={classes.emptyText}>
                        None of the selected vehicles have sensors.
                    </Typography>
                )}
            </Box>
            <Button
                size="small"
                onClick={handleCreateShare}
                variant="contained"
                startIcon={<ScreenShareIcon />}
                className={classes.shareButton}
                disabled={disableCreateShare()}
            >
                Share
            </Button>
        </Box>
    );
};

export default SubAccountShareAllVehicles;
